import {
  INIT_BANNER_LIST_REQUEST,
  SET_BANNER_LIST,
  ERROR_BANNER_LIST,
  ADD_BANNER,
  ERROR_ADD_BANNER,
  DELETE_BANNER,
  ERROR_DELETE_BANNER
} from './action';

const initialState = {
  banners: [],
  loading: false,
  error: ''
};

const bannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_BANNER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: ''
      };
    case SET_BANNER_LIST:
      return {
        ...state,
        loading: false,
        banners: action.payload,
        error: ''
      };
    case ERROR_BANNER_LIST:
      return {
        ...state,
        banners:[],
        loading: false,
        error: action.payload
      };
    case ADD_BANNER:
      return {
        ...state,
        error: ''
      };
    case ERROR_ADD_BANNER:
      return {
        ...state,
        error: action.payload
      };
    case DELETE_BANNER:
      return {
        ...state,
        error: ''
      };
    case ERROR_DELETE_BANNER:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export default bannerReducer;
